module.exports = __webpack_public_path__ + "img/219.03af7a37.jpg";